import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FilterBothIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M6.9 8.55004C6.56 7.87004 5.45 7.87004 5.11 8.55004C4.74 9.30004 4.06 10.12 3.34 11C1.78 12.9 0 15.06 0 17.91C0 21.27 2.69 24 6 24C9.31 24 12 21.27 12 17.91C12 15.06 10.23 12.9 8.66 11C7.94 10.13 7.27 9.30004 6.89 8.55004H6.9ZM6 22C3.79 22 2 20.17 2 17.91C2 15.78 3.47 13.99 4.88 12.27C5.27 11.79 5.65 11.33 6 10.86C6.34 11.32 6.73 11.79 7.12 12.27C8.54 13.99 10 15.78 10 17.91C10 20.17 8.21 22 6 22Z"
        fill={color}
      />
      <path
        d="M17 0C13.14 0 10 3.14 10 7C10 10.86 13.14 14 17 14C20.86 14 24 10.86 24 7C24 3.14 20.86 0 17 0ZM22 7C22 7.52 21.9 8.02 21.75 8.49L18 6.41V2.1C20.28 2.56 22 4.58 22 7ZM17 12C14.24 12 12 9.76 12 7C12 4.59 13.72 2.57 16 2.1V7C16 7.36 16.2 7.7 16.51 7.87L20.77 10.24C19.85 11.31 18.51 12 16.99 12H17Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FilterBothIcon.displayName = 'FilterBothIcon';
